import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusesSection } from '../components/BonusesSection';
import { TargetAudienceSection } from '../components/TargetAudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { PrivateCircleSection } from '../components/PrivateCircleSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a0e27] text-slate-50 font-sans selection:bg-yellow-500/30 selection:text-yellow-200" data-id="element-477">
      <Hero data-id="element-478" />
      <ProblemSection data-id="element-479" />
      <SolutionSection data-id="element-480" />
      <BonusesSection data-id="element-481" />
      <TargetAudienceSection data-id="element-482" />
      <HowItWorksSection data-id="element-483" />
      <FAQSection data-id="element-484" />
      <PricingSection data-id="element-485" />
      <PrivateCircleSection data-id="element-486" />
      <Footer data-id="element-487" />
      <RecentPurchaseToast data-id="element-488" />
    </main>;
}